import { Transaction } from 'grts-utils/types/Transaction';
import TransactionItem from './TransactionItem';

import './index.css';

interface Props {
  transactions: Transaction[] | null;
}

const LatestTransactions: React.FC<Props> = (props: Props) => {
  const { transactions } = props;

  if (!transactions?.length) {
    return null;
  }

  return (
    <div className="lt-container" style={{ paddingLeft: 16 }}>
      {transactions.map((transaction) => (
        <TransactionItem
          key={`${transaction.botId}-${transaction.id}`}
          transaction={transaction}
        />
      ))}
    </div>
  );
};

export default LatestTransactions;
